import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { hotSymbolsDataProvider } from './dataProvider';

// 注册 hot-symbols 模块的数据提供者
export function initHotSymbolsDataProvider() {
  registerModuleDataProvider(Resources.hotSymbols, hotSymbolsDataProvider);
}

// 自动初始化
initHotSymbolsDataProvider();
